/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type SnippetUpdateVisibility = typeof SnippetUpdateVisibility[keyof typeof SnippetUpdateVisibility] | null;


export const SnippetUpdateVisibility = {
  private: 'private',
  shared: 'shared',
} as const;
